import React, { Component } from 'react';
import { BulkDownload } from './components/postlist/BulkDownload';
import { Post } from './components/postlist/Post';
import { getTopicLabel } from './tools';
import _ from 'underscore';
import qs from "query-string";


class PostList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			downloadPostList: [],
			selectAll: false,
		};
		this.toggleDownloadAll = this.toggleDownloadAll.bind(this);
		this.toggleDownloadPost = this.toggleDownloadPost.bind(this);
	}

	toggleDownloadAll(value) {
		let downloadPostList = [];
		if (value) {
			this.props.filteredPostList.forEach(function(section) {
				const postIds = _.pluck(section[1], 'id');
				downloadPostList = _.union(downloadPostList, postIds);
			});
		}
		this.setState({
			selectAll: value,
			downloadPostList: downloadPostList,
		});
	}

	toggleDownloadPost(post, addToDownloadList) {
		let downloadPostList = this.state.downloadPostList;
		if ( addToDownloadList ) {
			downloadPostList.push(post.id);
			downloadPostList = _.uniq(downloadPostList);
		} else {
			downloadPostList = _.without(downloadPostList, post.id);
		}
		this.setState({
			downloadPostList: downloadPostList
		});
	}

	render() {
		let count = 0;
		this.props.filteredPostList.forEach(function (section) {
			count = count + section[1].length;
		});

		let openAccordion = false;
		const queryString = qs.parse(window.location.search);
		if ( ( undefined !== queryString['filterCompulsory'] && 'false' !== queryString['filterCompulsory'] )
			|| undefined !== queryString['filterTopics']
			|| undefined !== queryString['filterDocumentTypes']
			|| undefined !== queryString['filterLanguages'] ) {
				openAccordion = true;
		}

		return (
			<>
				{this.state.downloadPostList.length === 0 ? (
					<h5>All topics</h5>
				) : (
					<h5>Your topics results</h5>
				)}

				<div className="employee-comms-results-group">
					<BulkDownload
						downloadPostList={this.state.downloadPostList}
						filteredPosts={this.props.filteredPostList}
						toggleDownloadAll={this.toggleDownloadAll}
					/>
					{this.props.filteredPostList.map(topic => (
						// removed .files becuase it causes conflict with Bootstrap Accordion.
						<div key={topic[0]} className="employee-comms-results--topic">
							<h2
								id={"heading-document-" + topic[0]}
								data-bs-toggle="collapse"
								data-bs-target={"#" + topic[0]}
								aria-controls={topic[0]}
								className={"employee-comms-results-group-title h5" + (openAccordion ? "" : " collapsed")}
							>
								{getTopicLabel(topic[0])}<i className="icon-accordion"></i>
							</h2>
							<div
								className={`employee-comms-results-documents-container collapse ${(openAccordion ? " show" : "") }`}
								id={topic[0]}
								aria-labelledby={"heading-document-" + topic[0]}
							>
								{topic[1].map(post => (
									<Post
										post={post}
										key={topic[0] + '-' + post.id}
										toggleDownloadPost={this.toggleDownloadPost}
										downloadPostList={this.state.downloadPostList}
										topic={topic[0]}
									/>
								))}
							</div>
						</div>
					))}
				</div>

				<span id="download-mobile-btn" className="download-mobile multi-download-button d-block d-md-none">
					<a className="btn has-cobalt-color m-0 w-100" role="button" href="#download">
						{this.state.downloadPostList.length < count ? 'Download selected: ' + this.state.downloadPostList.length : 'Download all'}
					</a>
				</span>

			</>
		);
	}
}

export default PostList;
